<div class="mat-form-field-wrapper" style="width: 100%;">
  <mat-label style="font-size :1.2rem">{{ fieldObject.fieldName }}</mat-label> <br>
  <mat-slider thumbLabel="true" [formControl]="formControlRef" color="primary" ></mat-slider>
  <mat-error *ngIf="fieldErrors[fieldObject.fieldName]">
    {{ fieldErrors[fieldObject.fieldName] }}
  </mat-error>
</div>